import React, { useState, useRef, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { PlusCircle, ArrowLeft, ChevronLeft, User } from 'react-feather';
import {
    Box,
    Button,
    TextField,
    Typography,
    Autocomplete,
    Switch,
    Avatar,
    FormControlLabel,
    FormControl,
    RadioGroup,
    Radio,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authApi, formauthApi } from '../../api/api';
import Toastmessage from '../../components/Toast';
import { useDispatch } from 'react-redux'
import { logout } from '../../features/auth/AuthSlice';
import { set } from 'date-fns';


const RequiredLabel = ({ children }) => (
    <>
        {children} <span style={{ color: 'red' }}>*</span>
    </>
);

export default function AddNewUserRole() {
    const fileInputRef = useRef(null);
    const inputRefs = useRef({});
    const [profile_image, setImageURL] = useState(null);
    const [countryOptions, setCountryOptions] = useState([{ id: 1, name: 'USA' }]);
    const [stateOptions, setStateOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [professionalOptions, setProfessionalOptions] = useState([]);
    const [errors, setErrors] = useState({});
    const [userRoleList, setUserRoleList] = useState({});
    const [isLoading, setIsloading] = useState(false);
    const [formData, setFormData] = useState({
        userName: '',
        email: '',
        contactNumber: '',
        altContactNumber: '',
        address: '',
        gender: '',
        profileImg: '',
        city: '',
        location: { id: '', location_name: ''},
        state: { id: '', state_name: '', shortCode: '' },
        country: { id: 1, name: 'USA' },
        pinCode: '',
        initials: '',
        userRole: '',
        professionalType: '',
        bankDetails: '',
        accountEmail: '',
        password: '',
        confirmPassword: '',
        isActive: true,
    });


    const token = useSelector((state_id) => state_id.auth.token); // Get the token from Redux
    const userID = useSelector((state_id) => state_id.auth.id); // Get the userID from Redux

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleChange = (field) => (event, value) => {
        setFormData({ ...formData, [field]: value ?? event.target.value });
    };
    const handleActiveChange = (event) => {
        setFormData({ ...formData, isActive: event.target.checked });
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageURL(reader.result);
                setFormData({ ...formData, profileImg: file }); // Set the file object in formData
            };
            reader.readAsDataURL(file);
        }
    };
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };


    useEffect(() => {
        listStates()
        listLocation()
        fetchDesignation()
        fetchListRole()
    }, [])


    const fetchDesignation = async () => {
        const input_token = 'DESIGNATION'; // Replace with your actual token
        const apiUrl = 'list_of_designation'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const filteredDesignations = data.designations.filter(designation => designation.status === 1);
                setProfessionalOptions(filteredDesignations);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    const fetchListRole = async () => {
        const input_token = 'ROLES_MASTER'; // Replace with your actual token
        const apiUrl = 'list_of_roles_master'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setUserRoleList(data.roles)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }


    const listStates = async () => {
        const input_token = 'STATES'; // Replace with your actual token
        const apiUrl = 'list_of_states'; // Replace with the actual API endpoint

        const dataInput = {
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.list_of_states.map(state_id => ({
                    id: state_id.id,
                    state_name: state_id.state_name,
                    shortCode: state_id.state_short_code
                }));

                setStateOptions(statesArray);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }


    const listLocation = async () => {
        const input_token = 'LOCATIONS'; // Replace with your actual token
        const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.locations.map(location_id => ({
                    id: location_id.id,
                    location_name: location_id.location_name,
                }));
                setLocationOptions(statesArray);
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }

    const validateForm = () => {
        const newErrors = {};
        const phoneNumberPattern = /^(?:\+1\s?)?(\d{10})$/; // Matches optional +1 or 1 followed by 10 digits

        // User Name validation: Required and must be at least 4 characters long
        if (!formData.userName || formData.userName.trim() === '') {
            newErrors.userName = "User name is required";
        } else if (formData.userName.length < 4) {
            newErrors.userName = "User name must be at least 4 characters long";
        }

        // Email validation: Required and valid email format
        if (!formData.email || formData.email.trim() === '') {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter a valid email address";
        }

        // Contact Number validation: Required and must be a valid 10-digit number
        if (!formData.contactNumber || formData.contactNumber.trim() === '') {
            newErrors.contactNumber = "Contact number is required";
        } else if (!phoneNumberPattern.test(formData.contactNumber.replace(/\s+/g, ''))) {
            newErrors.contactNumber = "Contact number must be a valid 10-digit number (e.g., +1 1234567890)";
        }

        // Alternative Contact Number validation: Optional but must follow the same pattern if provided
        if (formData.altContactNumber && formData.altContactNumber.trim() !== '') {
            if (!phoneNumberPattern.test(formData.altContactNumber.replace(/\s+/g, ''))) {
                newErrors.altContactNumber = "Alternative contact number must be a valid 10-digit number (e.g., +1 1234567890)";
            }
        }

        // Address validation: Required
        if (!formData.address || formData.address.trim() === '') {
            newErrors.address = "Address is required";
        }

        // Address validation: Required
        if (!formData.gender || formData.gender.trim() === '') {
            newErrors.gender = "Gender is required";
        }

        // State validation: Ensure state.id is not empty
        if (!formData.state?.id || String(formData.state?.id).trim() === '') {
            newErrors.state = "State is required";
        }
        
        // Location validation: Ensure Location.id is not empty
        if (!formData.location?.id || String(formData.location?.id).trim() === '') {
            newErrors.location = "location is required";
        }

        // Professional validation: Ensure Professional.id is not empty
        if (!formData.professionalType?.id || String(formData.professionalType?.id).trim() === '') {
            newErrors.professionalType = "Designation type is required";
        }

        // userRoleidation: Ensure userRoleis not empty
        if (!formData.userRole?.id || String(formData.userRole?.id).trim() === '') {
            newErrors.userRole = "userRolee is required";
        }

        // User Initials validation: Required
        if (!formData.initials || formData.initials.trim() === '') {
            newErrors.initials = "Initials is required";
        }

        // City validation
        if (!formData.city || formData.city.trim() === '') {
            newErrors.city = "City is required";
        } else if (!/^[a-zA-Z\s]+$/.test(formData.city)) {
            newErrors.city = "City name must contain only letters and spaces";
        }

        // Pin Code validation
        if (!formData.pinCode || formData.pinCode.trim() === '') {
            newErrors.pinCode = "Zipcode is required";
        } else if (!/^\d{5}(-\d{4})?$/.test(formData.pinCode)) {
            newErrors.pinCode = "Invalid Zipcode format. It must be 5 digits or 5 digits followed by a hyphen and 4 digits (e.g., 12345 or 12345-6789)";
        }

        // User Bank validation: Required
        if (!formData.bankDetails || formData.bankDetails.trim() === '') {
            newErrors.bankDetails = "Bank details is required";
        }

        // // Password validation
        // if (!formData.password || formData.password.trim() === '') {
        //     newErrors.password = "Password is required";
        // } else if (formData.password.length < 6) {
        //     newErrors.password = "Password must be at least 6 characters long";
        // }

        // // Confirm Password validation
        // if (!formData.confirmPassword || formData.confirmPassword.trim() === '') {
        //     newErrors.confirmPassword = "Confirm password is required";
        // } else if (formData.password !== formData.confirmPassword) {
        //     newErrors.confirmPassword = "Passwords do not match";
        // }

        // Profile Image validation (optional)
        if (formData.profileImg) {
            const image = formData.profileImg;
            const validImageTypes = ['image/jpeg', 'image/png'];
            const maxSize = 2 * 1024 * 1024; // 2MB

            if (!validImageTypes.includes(image.type)) {
                newErrors.profileImg = "Please upload a valid image (JPG, JPEG, PNG)";
            } else if (image.size > maxSize) {
                newErrors.profileImg = "Image size must be less than 2MB";
            }
        }

        // Set errors and return validation result
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission behavior


        if (!validateForm()) {
            return; // Exit if validation fails
        }

        const addClientApi = async () => {
            setIsloading(true);
            const input_token = formData.email + 'CREATE_EMP';
            const apiUrl = 'create_firm_employee';
            // Create a FormData object
            const formDataToSend = new FormData();

            // Append form fields
            formDataToSend.append('login_user_id', userID); // From login_user_id
            formDataToSend.append('designation_id', formData?.professionalType?.id);
            formDataToSend.append('full_name', formData.userName);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('phone_number', formData.contactNumber);
            formDataToSend.append('alt_phone_number', formData.altContactNumber);
            formDataToSend.append('address', formData.address);
            formDataToSend.append('gender', formData.gender);
            formDataToSend.append('bank_details', formData.bankDetails);
            formDataToSend.append('role_id', formData?.userRole?.id);
            formDataToSend.append('state_id', formData?.state?.id);
            formDataToSend.append('location', formData?.location?.id);
            formDataToSend.append('initial', formData.initials);
            formDataToSend.append('city', formData.city);
            formDataToSend.append('zip_code', formData.pinCode);
            formDataToSend.append('status', formData.isActive ? 1 : 0);
            // formDataToSend.append('password', formData.password);

            if (formData.profileImg) {
                formDataToSend.append('profile_image', formData.profileImg);
            }
            try {
                const data = await formauthApi(input_token, formDataToSend, apiUrl, token, true);

                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setTimeout(() => navigate(-1), 2000);
                } else if (data && data.message === 'Token has expired') {
                    setIsloading(false);
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    setIsloading(false);
                    await Toastmessage('No response from server', false);
                } else {
                    setIsloading(false);
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                setIsloading(false);
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }
        };

        addClientApi();
    };
    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Add New User
                    </Typography>
                </Box>

                {/* Right Section */}
                <Button
                    variant="outlined"
                    component={Link}
                    to="/user"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Back to User List
                </Button>
            </Box>

            <Box className="card-box" p={3} sx={{ borderRadius: '8px', border: '1px solid var(--border-color)', m: 3 }} >
                {/* Header Section */}
                <Box className="sub-header">
                    <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
                        {/* <Link to="/user" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                <ArrowLeft size={20} style={{ marginRight: '8px' }} />  */}
                        Add New User
                        {/* </Link> */}
                    </Typography>
                    <FormControlLabel
                        control={<Switch checked={formData.isActive} onChange={handleActiveChange} />}
                        label={
                            <Typography sx={{ color: formData.isActive ? 'green' : 'red', fontWeight: 'bold' }}>
                                Active : {formData.isActive ? 'Yes' : 'No'}
                            </Typography>
                        }
                    />
                </Box>
                {/* Form Fields */}
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>User Name</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the User Name"
                            value={formData.userName}
                            error={!!errors.userName}
                            helperText={errors.userName}
                            inputProps={{ maxLength: 100 }}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Regular expression to allow only letters, spaces, and special characters
                                const regex = /^[^0-9]*$/;
                                if (regex.test(value)) {
                                    handleChange('userName')(e); // Call the existing change handler
                                }
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />

                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>User Email ID</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Email ID"
                            value={formData.email}
                            error={!!errors.email}
                            helperText={errors.email}
                            inputProps={{ maxLength: 50 }}
                            onChange={handleChange('email')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>User Contact Number</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Contact Number"
                            value={formData.contactNumber}
                            error={!!errors.contactNumber}
                            helperText={errors.contactNumber}
                            onChange={handleChange('contactNumber')}
                            inputProps={{ maxLength: 12 }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography>User Alternative Contact Number</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Alternative Contact Number"
                            value={formData.altContactNumber}
                            error={!!errors.altContactNumber}
                            helperText={errors.altContactNumber}
                            onChange={handleChange('altContactNumber')}
                            inputProps={{ maxLength: 12 }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography><RequiredLabel>User Address</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            variant="outlined"
                            placeholder="Enter the Address"
                            value={formData.address}
                            error={!!errors.address}
                            helperText={errors.address}
                            inputProps={{ maxLength: 300 }}
                            onChange={handleChange('address')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Gender</RequiredLabel></Typography>
                        <FormControl component="fieldset" error={!!errors.gender}>
                            <RadioGroup
                                row
                                aria-label="gender"
                                name="gender"
                                value={formData.gender}
                                // onChange={(event, newValue) => setGender(newValue)}
                                onChange={handleChange('gender')}
                            >
                                <FormControlLabel value="female" control={<Radio />} label="Female" />
                                <FormControlLabel value="male" control={<Radio />} label="Male" />
                                <FormControlLabel value="other" control={<Radio />} label="Other" />
                            </RadioGroup>
                            {errors.gender && (
                                <Typography variant="caption" color="error">
                                    {errors.gender}
                                </Typography>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography>User Photo</Typography>
                        <Box display="flex" flexDirection="row" alignItems="center" gap={3}>
                            <Avatar
                                variant="rounded"
                                src={profile_image || ""}
                                sx={{ width: 100, height: 100, mb: 1 }}
                            />
                            <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
                                <input
                                    type="file"
                                    accept="image/jpeg, image/png"
                                    style={{ display: 'none' }}
                                    ref={fileInputRef}
                                    onChange={handleFileUpload}
                                />
                                <Button sx={{ backgroundColor: 'var(--back-button)', color: "var(--back-color)", fontWeight: "600", padding: "10px 20px" }} onClick={handleButtonClick}>
                                    Upload Image
                                </Button>
                                <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
                                    JPG or PNG no larger than 5 MB
                                </Typography>
                                {/* Display image error */}
                                {errors.profile_image && (
                                    <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                                        {errors.profile_image}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    </Grid>


                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>User Initials</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter initials"
                            value={formData.initials}
                            error={!!errors.initials}
                            inputProps={{ maxLength: 3 }}
                            helperText={errors.initials}
                            onChange={handleChange('initials')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Country</RequiredLabel></Typography>
                        <Autocomplete
                            options={countryOptions}
                            getOptionLabel={(option) => option.name}
                            fullWidth
                            disabled
                            value={formData.country}
                            error={!!errors.country}
                            helperText={errors.country}
                            onChange={handleChange('country')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Country"
                                    variant="outlined"
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>State</RequiredLabel></Typography>
                        <Autocomplete
                            options={stateOptions}
                            getOptionLabel={(option) => option.state_name}
                            value={formData.state} // Match by ID
                            fullWidth
                            onChange={handleChange('state')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select state"
                                    variant="outlined"
                                    error={!!errors.state} // Move error here
                                    helperText={errors.state} // Move helperText here
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />

                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>City</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the city name"
                            value={formData.city}
                            error={!!errors.city}
                            helperText={errors.city} // Display error message
                            onChange={handleChange('city')}
                            inputRef={(el) => (inputRefs.current.city = el)}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Location</RequiredLabel></Typography>
                        <Autocomplete
                            options={locationOptions}
                            getOptionLabel={(option) => option.location_name}
                            value={formData.location} // Match by ID
                            fullWidth
                            onChange={handleChange('location')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select location"
                                    variant="outlined"
                                    error={!!errors.location} // Move error here
                                    helperText={errors.location} // Move helperText here
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Zipcode</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter the Zipcode"
                            value={formData.pinCode}
                            error={!!errors.pinCode}
                            helperText={errors.pinCode}
                            onChange={handleChange('pinCode')}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>User Role</RequiredLabel></Typography>
                        <Autocomplete
                            options={userRoleList}
                            fullWidth
                            onChange={handleChange('userRole')}
                            value={formData.userRole}
                            getOptionLabel={(option) => option.role_name || ''}
                            isOptionEqualToValue={(option, value) => option.id === value?.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select User Role"
                                    variant="outlined"
                                    error={!!errors.userRole}
                                    helperText={errors.userRole}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Designation Type</RequiredLabel></Typography>
                        <Autocomplete
                            options={professionalOptions}
                            fullWidth
                            getOptionLabel={(option) => option.designation_name || ''}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            value={formData.professionalType}
                            onChange={handleChange('professionalType')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Designation Type"
                                    variant="outlined"
                                    error={!!errors.professionalType}
                                    helperText={errors.professionalType}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography><RequiredLabel>Bank Details</RequiredLabel></Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Bank Details"
                            value={formData.bankDetails}
                            error={!!errors.bankDetails}
                            helperText={errors.bankDetails}
                            onChange={handleChange('bankDetails')}
                            inputProps={{ maxLength: 100 }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                        />
                    </Grid>
                </Grid>
                <Box mt={4} textAlign="center">
                    <Button
                        type="submit"
                        variant="contained"
                        startIcon={<PlusCircle size={20} />}
                        onClick={handleSubmit}
                        disabled={isLoading}
                         className='btn-theme-button'
                    >
                        Add New User
                    </Button>
                </Box>

            </Box>
            
        </Box>

    );
}

